// Single source of truth for ezp_users.role numbering and the 3
// employee-access personas built on top of it. Consumed by ProtectedRoute,
// sidebarNavConfig.js, AccessDenied.jsx and Login.jsx. Role 4 is intentionally reserved/unused (future persona).
// Role 7 is HR staff (ezp_role code 'hr'): the HR screens and nothing else.
export const ROLE_IDS = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  VENDOR: 3,
  CREW: 5,
  SUPPORT: 6,
  HR: 7,
  // An outside company's person who answers a buyer's RFQs (Procurement). Not staff of any tenant.
  SUPPLIER: 8,
};

export const PERSONA = {
  ADMIN_VENDOR: "ADMIN_VENDOR",
  SUPPORT: "SUPPORT",
  CREW: "CREW",
  HR: "HR",
  SUPPLIER: "SUPPLIER",
  UNKNOWN: "UNKNOWN",
};

export function getPersonaForRole(role) {
  const r = Number(role);
  if ([ROLE_IDS.SUPER_ADMIN, ROLE_IDS.ADMIN, ROLE_IDS.VENDOR].includes(r)) return PERSONA.ADMIN_VENDOR;
  if (r === ROLE_IDS.SUPPORT) return PERSONA.SUPPORT;
  if (r === ROLE_IDS.CREW) return PERSONA.CREW;
  if (r === ROLE_IDS.HR) return PERSONA.HR;
  if (r === ROLE_IDS.SUPPLIER) return PERSONA.SUPPLIER;
  return PERSONA.UNKNOWN;
}

// Vendor-side staff accounts (Admin/Crew/Support employees created under a
// vendor) skip the Vendor's own onboarding (industry/setup) checks on login
// and land straight on /dashboard - that onboarding is for the account
// owner (Vendor, role 3), not staff. Super Admin (role 1) is intentionally
// excluded here: it's the separate platform master-console login, unrelated
// to this per-vendor staff flow.
export function isStaffRole(role) {
  const r = Number(role);
  return [ROLE_IDS.ADMIN, ROLE_IDS.CREW, ROLE_IDS.SUPPORT, ROLE_IDS.HR].includes(r);
}

export function isHrRole(role) {
  return Number(role) === ROLE_IDS.HR;
}

export function isSupplierRole(role) {
  return Number(role) === ROLE_IDS.SUPPLIER;
}

// Where a staff (or supplier) login lands after signing in: HR staff go straight to HR (they have no
// dashboard); a supplier has its own portal.
export function staffLandingPath(role) {
  if (isSupplierRole(role)) return "/supplier";
  return isHrRole(role) ? "/hr" : "/dashboard";
}

// Account-owner-only chrome (profile menu item, setup-completion status,
// billing plan). Narrower than PERSONA.ADMIN_VENDOR - Admin (role 2) is
// staff, not the account owner, so it's deliberately excluded here even
// though it gets full screen access elsewhere.
export function canSeeAccountOwnerInfo(role) {
  const r = Number(role);
  return r === ROLE_IDS.SUPER_ADMIN || r === ROLE_IDS.VENDOR;
}
